import React from "react";
import "./Home.css";
import nasif from "../../images/nasif.jpg";
import skill1 from "../../images/skill1.png";
import skill2 from "../../images/skill2.png";
import skill3 from "../../images/skill3.png";
import { Typewriter } from "react-simple-typewriter";
// import { motion } from "framer-motion";
// import { Link } from "react-scroll";
// import { fadeIn } from "../../variants";

const Home = () => {
  return (
    <main className="hero" id="home">
      <div className="container f_flex">
        <div className="left top">
          <h3>WELCOME TO MY WORLD</h3>

          <h1>
            Hi, I’m <span>Nasif Jihan</span> <span class="wave-icon">🖐️</span>
          </h1>

          <h2>
            a
            <span>
              <Typewriter
                words={[" MERN Developer.", " Frontend Developer."]}
                loop
                cursor
                cursorStyle="|"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </span>
          </h2>

          <p>
            I specialize in developing dynamic and responsive web applications
            using the MERN stack — MongoDB, Express.js, React, and Node.js.
            Whether it's creating a sleek frontend with React or building a
            robust backend with Node.js and Express, I bring a comprehensive
            skill set to every project. My goal is to deliver high-quality,
            user-centric solutions that enhance digital experiences.
          </p>

          <div className="hero_btn d_flex">
            <div className="col_1">
              <h4>MY RESUME</h4>

              {/* <a href="https://drive.usercontent.google.com/download?id=1it6xASTSXLcpXJLff4npR3BgHAKsLCx9&export=download"> */}
              <a href="https://drive.usercontent.google.com/download?id=1it6xASTSXLcpXJLff4npR3BgHAKsLCx9&export=download">
                <button class="btn btn-lg flex justify-center items-center gap-2 btn_shadow">
                  <i class="fas fa-download"></i> Resume
                </button>
              </a>

              {/* <button className="btn_shadow">
                <img src={skill1} alt="" />
              </button>
              <button className="btn_shadow">
                <img src={skill2} alt="" />
              </button>
              <button className="btn_shadow">
                <img src={skill3} alt="" />
              </button> */}
            </div>

            <div className="col_1">
              <h4>FIND WITH ME</h4>

              <div className="button">
                <a
                  href="https://www.facebook.com/nasifjihan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn_shadow">
                    <i className="fab fa-facebook-f"></i>
                  </button>
                </a>
                <a
                  href="https://github.com/nasifjihan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn_shadow">
                    <i className="fab fa-github"></i>
                  </button>
                </a>
                <a
                  href="https://www.linkedin.com/in/nasifjihan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn_shadow">
                    <i className="fab fa-linkedin-in"></i>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="right">
          <div className="right_img">
            {/* <img src={nasif} alt="" /> */}
            <div className="myimg"></div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
